import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { TalkToAyushDialog } from "@/components/TalkToAyushDialog";

export function TalkToAyushFab() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid="talk-fab"
        aria-label="Talk to Ayush"
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 flex h-14 items-center gap-2 rounded-full bg-foreground px-5 font-mono text-xs uppercase tracking-widest text-background shadow-[0_10px_30px_rgba(0,0,0,0.25)] transition-transform hover:-translate-y-0.5 active:scale-95 md:hidden print:hidden"
      >
        <MessageCircle className="h-4 w-4" />
        Talk to Ayush
      </button>
      <TalkToAyushDialog source="mobile-fab" open={open} onOpenChange={setOpen} />
    </>
  );
}
